module.exports = __webpack_public_path__ + "img/unifast.084a7c75.svg";